import { useEffect, useState } from "react";
import Utility from '../api/utility';
import { useDispatch } from "react-redux";
import { show } from "../reducers/notificationSlice";
import { Grid as GridLoader } from 'react-loader-spinner';
import * as React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography, Chip } from "@mui/material";
import { School } from "@mui/icons-material";
import ModernCardGrid from './ModernCardGrid';


const FORM_INITIAL_STATE = { id: 0, name: "" };

export default function InstitutionType() {
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState(FORM_INITIAL_STATE);

    function fetchList() {
        Utility.getInstitutionTypes()
            .then(({ data }) => setData(data))
            .catch((err) => dispatch(show({ message: err.response.data.message, open: true, severity: "error" })));
    }

    useEffect(() => {
        fetchList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleEdit = (item) => {
        setFormData({
            id: item.id,
            name: item.name,
        });
        setOpen(true);
    };

    const handleDelete = (item) => {
        if (window.confirm(`Are you sure you want to delete "${item.name}"?`)) {
            Utility.deleteInstitutionType(item.id)
                .then(() => {
                    dispatch(show({ message: "Institution Type deleted successfully", open: true, severity: "success" }));
                    setData(data.filter((ele) => ele.id !== item.id));
                })
                .catch((err) => dispatch(show({ message: err.response.data.message, open: true, severity: "error" })));
        }
    };

    const handleAdd = () => {
        setFormData(FORM_INITIAL_STATE);
        setOpen(true);
    };

    const renderCard = (item) => (
        <Box>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                mb: 1.5
            }}>
                <Box sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 12px rgba(240, 147, 251, 0.3)'
                }}>
                    <School sx={{ color: 'white', fontSize: 28 }} />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            fontSize: '1.1rem',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            color: 'text.primary'
                        }}
                    >
                        {item.name}
                    </Typography>
                    <Chip
                        label={`ID: ${item.id}`}
                        size="small"
                        sx={{
                            mt: 0.5,
                            height: 20,
                            fontSize: '0.7rem',
                            bgcolor: 'action.hover'
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );

    return (
        data?.length > 0 ? (
            <>
                <ModernCardGrid
                    data={data}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    onAdd={handleAdd}
                    searchPlaceholder="Search institution types..."
                    addButtonText="Add Institution Type"
                    renderCard={renderCard}
                    emptyMessage="No institution types found"
                />
                <AddInstitutionType {...{ open, setOpen, formData, setFormData, fetchList }} />
            </>
        ) : (
            <Box className="h-[600px] justify-center flex items-center">
                <GridLoader />
            </Box>
        )
    );
}

function AddInstitutionType({ open, setOpen, formData, setFormData, fetchList }) {

    const dispatch = useDispatch();
    return (
        <Dialog open={open} onClose={() => {
            setOpen(() => false);
            setFormData(() => FORM_INITIAL_STATE);
        }}>
            <DialogTitle className="font-bold text-xl text-center">Add Institution Type</DialogTitle>
            <DialogContent>
                <Box className="flex flex-col gap-10 p-10 w-[400px] max-w-full mt-10">
                    <TextField label="Name"
                        value={formData.name}
                        onChange={(e) => setFormData((_d) => ({
                            ..._d,
                            name: e.target.value
                        }))}
                    />
                </Box>
                <DialogActions>
                    {formData.id === 0 ? <Button variant="contained" onClick={() => {
                        Utility.addInstitutionType({ name: formData.name })
                            .then(() => {
                                dispatch(show({ message: "Institution Type added successfully", open: true, severity: "success" }));
                                setOpen(() => false);
                                fetchList();
                            })
                            .catch((err) => dispatch(show({ message: err.response.data.message, open: true, severity: "error" })));

                    }}>Add</Button>

                        :

                        <Button variant="contained" onClick={() => {
                            console.log(formData);
                            Utility.updateInstitutionType({ name: formData.name }, formData.id)
                                .then(() => {
                                    dispatch(show({ message: "Institution Type updated successfully", open: true, severity: "success" }));
                                    setOpen(() => false);
                                    fetchList();
                                })
                                .catch((err) => dispatch(show({ message: err.response.data.message, open: true, severity: "error" })));

                        }}>Update</Button>
                    }
                </DialogActions>
            </DialogContent>
        </Dialog>
    )
}
